var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.model && _vm.model != {})?_c('w-error',{attrs:{"model":_vm.model}}):_vm._e(),_c('table',{class:_vm.tableClass,staticStyle:{"margin-bottom":"2em"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }